import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";

export default function PrivacyPolicy() {
  useEffect(() => { document.title = "Privacy Policy — PodiumOne"; }, []);
  return (
    <div>
      <Navbar />
      <div className="relative z-10 max-w-3xl mx-auto px-4 pt-28 pb-16" data-testid="privacy-policy-page">
        <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/40">Legal</span>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2 mb-4">Privacy Policy</h1>
        <p className="text-white/50 mb-10">Effective Date: September 2026</p>

        <p className="text-white/60 leading-relaxed mb-8">
          PodiumOne (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) respects your privacy. This Privacy Policy
          explains how we collect, use, and safeguard your information when you visit our website and use
          our directory service.
        </p>

        <div className="space-y-4">
          <div className="glass rounded-2xl p-6" data-testid="privacy-section">
            <h2 className="font-display font-bold text-lg tracking-tight mb-3">1. Information We Collect</h2>
            <ul className="space-y-3 text-white/60 leading-relaxed list-disc pl-5">
              <li><span className="text-white font-semibold">Account Data:</span> When you register, we collect your email address and name for authentication and communication purposes.</li>
              <li><span className="text-white font-semibold">Financial Data:</span> We use Stripe to process all payments. We do not store or process your credit card numbers or bank credentials on our servers. All financial data is handled directly by Stripe.</li>
              <li><span className="text-white font-semibold">Public Directory Data:</span> The business information you submit for your directory listing (business name, location, WhatsApp number, website) is displayed publicly on our platform.</li>
            </ul>
          </div>

          <div className="glass rounded-2xl p-6" data-testid="privacy-section">
            <h2 className="font-display font-bold text-lg tracking-tight mb-3">2. How We Use Your Information</h2>
            <p className="text-white/60 leading-relaxed mb-3">We use the information we collect to:</p>
            <ul className="space-y-2 text-white/60 leading-relaxed list-disc pl-5">
              <li>Provide, operate, and maintain the PodiumOne platform.</li>
              <li>Process your one-time placement fees and bid upgrades.</li>
              <li>Send you transactional emails, such as account verification and outbid notifications.</li>
            </ul>
          </div>

          <div className="glass rounded-2xl p-6" data-testid="privacy-section">
            <h2 className="font-display font-bold text-lg tracking-tight mb-2">3. Cookies and Tracking</h2>
            <p className="text-white/60 leading-relaxed">
              We use essential cookies strictly necessary to provide you with the services available through
              our platform, such as keeping you logged in and securing your session. We do not use third-party
              behavioral tracking cookies.
            </p>
          </div>

          <div className="glass rounded-2xl p-6" data-testid="privacy-section">
            <h2 className="font-display font-bold text-lg tracking-tight mb-2">4. Data Sharing</h2>
            <p className="text-white/60 leading-relaxed">
              We do not sell, rent, or trade your personal information. We only share necessary data with
              trusted service providers (like Stripe for payments and Resend for transactional emails) to
              operate our platform.
            </p>
          </div>

          <div className="glass rounded-2xl p-6" data-testid="privacy-section">
            <h2 className="font-display font-bold text-lg tracking-tight mb-2">5. Contact Us</h2>
            <p className="text-white/60 leading-relaxed">
              If you have questions about this Privacy Policy or wish to request the deletion of your account
              and data, please contact us at{" "}
              <a href="mailto:admin@podiumone.to" className="text-blue-400 hover:text-blue-300 font-medium">admin@podiumone.to</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
